export default __webpack_public_path__ + "static/media/about-us-bg-min-7c5f45da.f46ab833.png";